import styled from 'styled-components'

export const AccordionContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0;

  gap: 16px;
  color: ${({ theme }) => theme.ds.colors.neutral700};
  font-size: ${({ theme }) => theme.ds.typography.size.medium};
  font-weight: ${({ theme }) => theme.ds.typography.weight.semiBold};
`

export const BallCounter = styled.div`
  border-radius: 25px;
  background: ${({ color }) => color};
  width: 36px;
  height: 36px;
  color: ${({ theme }) => theme.ds.colors.white};
  font-size: ${({ theme }) => theme.ds.typography.size.medium};
  font-weight: ${({ theme }) => theme.font.semiBold};
  display: flex;
  justify-content: center;
  align-items: center;
`

export const AccordionsWrapper = styled.div`
  /* min-width: 460px; */
`
export const PendenciesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
